module.exports = __webpack_public_path__ + "19ec07e85095b584f071ded0ef8c461a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Carousel/images/4.jpg
// module id = ./src/components/Carousel/images/4.jpg
// module chunks = 0